<template>
  <div class="login flex items-center h-screen w-full bg-green-600">
    <div
      class="w-full bg-white rounded-lg flex flex-col justify-items-center shadow-lg p-8 m-4 md:max-w-sm md:mx-auto"
    >
      <img src="@/assets/logo-plataforma_web_400.png" />
      <div class="flex flex-col w-full">
        <form
          class="w-full max-w-lg"
          id="signUpForm"
          @submit.prevent="registerSubmit"
        >
          <div class="w-full text-left pb-3 text-gray-900 text-2xl font-bold">
            Registro
          </div>
          <div class="flex flex-wrap -mx-3">
            <div class="w-full px-3 mb-6 md:mb-0">
              <label
                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                for="name"
                >Nombre(s)</label
              >
              <input
                class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                id="name"
                type="text"
                name="name"
                v-model="name"
              />
              <p v-if="errors.name" class="text-red-500 text-xs italic">
                Ingrese un nombre.
              </p>
            </div>
          </div>
          <div class="flex flex-wrap -mx-3">
            <div class="w-full px-3 mb-6 md:mb-0">
              <label
                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                for="lastname"
                >Apellido(s)</label
              >
              <input
                class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                id="lastname"
                type="text"
                name="lastname"
                v-model="lastname"
              />
              <p v-if="errors.name" class="text-red-500 text-xs italic">
                Ingrese un apellido.
              </p>
            </div>
          </div>
          <div class="flex flex-wrap -mx-3">
            <div class="w-full px-3 mb-6 md:mb-0">
              <label
                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                for="email"
                >Correo electrónico</label
              >
              <input
                class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                id="email"
                type="text"
                name="email"
                v-model="email"
              />
              <p v-if="errors.email" class="text-red-500 text-xs italic">
                Ingrese un correo electrónico.
              </p>
              <p v-if="errors.valid_email" class="text-red-500 text-xs italic">
                Ingrese un correo electrónico válido.
              </p>
            </div>
          </div>
          <div class="flex flex-wrap -mx-3">
            <div class="w-full px-3 mb-6 md:mb-0">
              <label
                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                for="password"
                >Contraseña</label
              >
              <input
                class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                id="password"
                type="password"
                name="password"
                v-model="password"
              />
              <p v-if="errors.password" class="text-red-500 text-xs italic">
                La contraseña debe tener al menos 8 caracteres, al menos un
                número, al menos una minúscula, al menos una mayúsculas y al
                menos un caracter entre estos !@#$%^&*.
              </p>
              <p
                v-if="errors.valid_password"
                class="text-red-500 text-xs italic"
              >
                La contraseña no coincide.
              </p>
            </div>
          </div>
          <div class="flex flex-wrap -mx-3">
            <div class="w-full px-3 mb-6 md:mb-0">
              <label
                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                for="password_again"
                >Repetir Contraseña</label
              >
              <input
                class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                id="password_again"
                type="password"
                name="password_again"
                v-model="password_again"
              />
              <p
                v-if="errors.password_again"
                class="text-red-500 text-xs italic"
              >
                Ingrese una contraseña.
              </p>
            </div>
          </div>
          <div class="flex justify-center">
            <vue-hcaptcha
              sitekey="cf7fc01e-97e2-492d-aa9a-2e0ecfcf269f"
              @verify="captchaVerify"
            ></vue-hcaptcha>
          </div>
          <div class="flex w-full justify-center pt-6">
            <button
              class="bg-purple-500 hover:bg-purple-700 px-4 py-2 text-center rounded-lg text-gray-100 tracking-wider uppercase font-bold disabled:opacity-75 disabled:cursor-default disabled:bg-purple-500"
              type="submit"
              :disabled="!tokenIsValid"
            >
              Registrar
            </button>
          </div>
          <div class="flex w-full justify-center pt-2">
            <a
              v-on:click="goToLogin()"
              class="cursor-pointer hover:text-gray-600 tracking-wider"
              >Iniciar sesión</a
            >
          </div>
        </form>
      </div>
    </div>
    <alert-dialog :showing="showingSuccess">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">
          Usuario registrado correctamente
        </div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-green-400"
            viewBox="0 0 24 24"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="redirectToLogin()"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>
    <alert-dialog :showing="showingError">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">{{ errorMessage }}</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-cdmx-red"
            viewBox="0 0 24 24"
          >
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingError = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>
  </div>
</template>

<style scoped>
.login {
  background-color: #f6f4fa;
  background-image: url("/apidev/img/bg1.jpg");
}
</style>

<script>
import AlertDialog from "./AlertDialog";
import VueHcaptcha from "@hcaptcha/vue-hcaptcha";

export default {
  data() {
    return {
      name: "",
      lastname: "",
      email: "",
      password: "",
      password_again: "",
      showingSuccess: false,
      showingError: false,
      errorMessage: "",
      errors: {
        email: false,
        valid_email: false,
        password: false,
        password_again: false,
        valid_password: false,
      },
      tokenIsValid: false,
    };
  },
  components: {
    AlertDialog,
    VueHcaptcha,
  },
  computed: {},
  methods: {
    registerSubmit() {
      const form = document.getElementById("signUpForm");
      const formData = new FormData(form);
      const validForm = this.checkFormRegister(formData);
      if (validForm) {
        let user_info = {
          email: this.email.trim(),
          password: this.password,
          type: "registrante",
          name: this.name,
          lastname: this.lastname,
        };

        this.axios
          .post("apidev/users/", user_info)
          .then((data) => {
            this.showingSuccess = true;
          })
          .catch((err) => {
            console.log(err);
            this.showingError = true;
          });
      }
    },
    checkFormRegister: function (data) {
      let re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      let paswordRexeg = /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,}$/;

      if (data.get("email") === "") {
        this.errors.email = true;
      } else {
        this.errors.email = false;
      }

      if (!re.test(data.get("email"))) {
        this.errors.valid_email = this.errors.email ? false : true;
      } else {
        this.errors.valid_email = false;
      }

      if (!paswordRexeg.test(data.get("password"))) {
        this.errors.password = true;
      } else {
        this.errors.password = false;
      }

      if (data.get("password_again") === "") {
        this.errors.password_again = true;
      } else {
        this.errors.password_again = false;
      }

      if (data.get("password") !== data.get("password_again")) {
        this.errors.valid_password = true;
        return false;
      } else {
        this.errors.valid_password = false;
      }

      if (data.get("name") === "") {
        this.errors.name = true;
      } else {
        this.errors.name = false;
      }

      if (data.get("last_name") === "") {
        this.errors.lastname = true;
      } else {
        this.errors.lastname = false;
      }

      if (
        this.errors.email ||
        this.errors.valid_email ||
        this.errors.name ||
        this.errors.lastname ||
        this.errors.password ||
        this.errors.password_again ||
        this.errors.valid_password
      ) {
        return false;
      }

      return true;
    },
    goToLogin() {
      this.$router.push({ path: "/login" });
    },
    redirectToLogin() {
      this.showingSuccess = false;
      this.goToLogin();
    },
    captchaVerify(token) {
      this.axios
        .post("apidev/users/register/verify", { token: token })
        .then((data) => {
          if (data.data.sucess === "ok") {
            this.tokenIsValid = true;
          } else {
            this.tokenIsValid = false;
          }
        })
        .catch((err) => {
          this.tokenIsValid = false;
          this.errorMessage = "Verificación fallida";
          this.showingError = true;
        });
    },
  },
};
</script>

<style scoped>
.bg-semi-75 {
  background-color: rgba(0, 0, 0, 0.75);
}
</style>
